module.exports = __webpack_public_path__ + "img/CF_2Y.541fafee.jpg";